// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3ZQOb","content":"ManualTimeModal_content__2-WXY"};